import config from "../../../config";
import getWebAppApiLoginUrlPrefix from "./getWebAppApiLoginUrlPrefix";

export default function canUseInternalWebBrowser(
  parsedUrl,
  { forceWebBrowser = false } = {}
) {
  if (forceWebBrowser) {
    return false;
  }

  const hostLower = String(parsedUrl?.host || "").toLowerCase();

  const allowedHosts = config.useInternalWebBrowserForHosts || [];
  if (allowedHosts.includes(hostLower)) {
    return true;
  }

  const loginUrlPrefix = getWebAppApiLoginUrlPrefix();
  const finalUrl = String(parsedUrl?.toString?.() || "");

  return finalUrl.startsWith(loginUrlPrefix);
}
